import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { addSkillDetailsIfOK, updateAddSkillDetailsFormValues, clearAddSkillDetailsFormValues, hideAddSkillDetailsModal } from '../../actions';
import { AddSkillDetailsModal } from './AddSkillDetailsModal';
import { downloadUrl } from '../../helpers';
import { Scoring } from '../../constants/scoring';

class AddSkillDetailsModalController extends Component {
    constructor(props) {
        super(props);

        this.formUpdated = this.formUpdated.bind(this);
        this.formSubmitted = this.formSubmitted.bind(this);
    }

    formSubmitted(event) {
        event.preventDefault();
        const {addSkillDetailsIfOK, data, scene, hideAddSkillDetailsModal, clearAddSkillDetailsFormValues} = this.props;
        //Fill in the necessary data that's not on the form
        data.activityIdentifier = scene;
        data.activityName = scene;
        data.activitySpecificData = "None";
        data.removalCandidate = false;

        addSkillDetailsIfOK(scene, data)
            .then(clearAddSkillDetailsFormValues)
            .then(hideAddSkillDetailsModal);
    }

    formUpdated(event) {
        const {updateAddSkillDetailsFormValues, data} = this.props;
        const {target} = event;

        const key = _.camelCase(target.name);
        let value = target.value;

        if(key === "scores"){
            if( target.checked ){
                value = Scoring.ScoresScores;
            }
            else{
                value = Scoring.ScoresDoesNotScore;
            }
        } 

        updateAddSkillDetailsFormValues({
            ...data,
            [key]: value,
            [`${key}Valid`]: isValid(key, target.value)
        });
    }

    render() {
        const {show, hideAddSkillDetailsModal, clearAddSkillDetailsFormValues, scene, data} = this.props;

        return (
            <AddSkillDetailsModal
                show={show}
                hide={() => {
                    clearAddSkillDetailsFormValues();
                    hideAddSkillDetailsModal();
                }}
                scene={scene}
                previewURL={downloadUrl(data.repository, data.path)}
                data={{
                    datasetValidation:                  validationState(data.datasetValid),
                    skillNameValidation:                validationState(data.skillNameValid),
                    formValid:                          formValid(data)
                }}
                updated={this.formUpdated}
                submitted={this.formSubmitted}
                />
        );
    }
}

const isValid = (name, value) => {
    switch(name) {
        case 'dataset':    return !isNaN(value);  
        case 'skillName':  return !!value;  
        default:           return false;
    }
};

const validationState = isValid => {
    return isValid ? 'success' : 'error';
};

const formValid = data => {
    return data.datasetValid && data.skillNameValid;
};

AddSkillDetailsModalController.propTypes = {
    show:                               PropTypes.bool.isRequired,
    hideAddSkillDetailsModal:           PropTypes.func.isRequired,
    scene:                              PropTypes.string.isRequired,
    addSkillDetailsIfOK:                PropTypes.func.isRequired,
    updateAddSkillDetailsFormValues:    PropTypes.func.isRequired,
    data:                               PropTypes.object.isRequired,
    clearAddSkillDetailsFormValues:     PropTypes.func.isRequired
};

const mapDispatchToProps = {
    addSkillDetailsIfOK,
    updateAddSkillDetailsFormValues,
    clearAddSkillDetailsFormValues,
    hideAddSkillDetailsModal
};

const mapStateToProps = state => ({
    scene: state.scene.current,
    data: state.ui.addSkillDetailsData,
    show: state.ui.addSkillDetails.show
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddSkillDetailsModalController);



// WEBPACK FOOTER //
// ./src/components/addSkillDetailsModal/AddSkillDetailsModalController.js